export default __webpack_public_path__ + "static/media/972.e4fb00d7.gif";